import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import { uiLocations } from 'constants/analytics';
import ScriptCreatorTitle from 'edit/ScriptCreatorTitle';
import ExportTrigger from 'triggers/ExportTrigger';
import SaveTrigger from 'triggers/SaveTrigger';
import ExitTriggerTankMix from '../triggers/ExitTriggerTankMix';

const baseString = 'vra-script-creator-header';
const classString = classNames({
  [`${baseString}`]: true
});
const ScriptCreatorHeader = ({
  exportOptionsIsOpen,
  isExitButtonVisible,
  isSaveTriggerEnabled,
  isExportTriggerEnabled,
  onClickCancelTrigger,
  onClickSaveTrigger,
  onClickExportTrigger,
  scriptId
}) => {
  const renderExitTrigger = () => {
    return (<ExitTriggerTankMix
      dataTestId='vra-exit-trigger'
      isVisible={isExitButtonVisible}
      onClickCancelTrigger={onClickCancelTrigger}
    />);
  };

  return (
    <section className={classString}>
      <ScriptCreatorTitle />
      <nav className={`${baseString}__nav`}>
        {isExportTriggerEnabled && (
          <ExportTrigger
            dataTestId='vra-export-trigger'
            exportOptionsIsOpen={exportOptionsIsOpen}
            onClickExportTrigger={onClickExportTrigger}
            uiLocation={uiLocations.EDIT}
          />
        )}
        {renderExitTrigger()}
        <SaveTrigger
          dataTestId='vra-save-trigger'
          isSaveTriggerEnabled={isSaveTriggerEnabled}
          onClickSaveTrigger={onClickSaveTrigger}
          scriptId={scriptId}
        />
      </nav>
    </section>
  );
};
ScriptCreatorHeader.propTypes = {
  exportOptionsIsOpen: propTypes.bool.isRequired,
  isExitButtonVisible: propTypes.bool.isRequired,
  isExportTriggerEnabled: propTypes.bool,
  isSaveTriggerEnabled: propTypes.bool.isRequired,
  onClickCancelTrigger: propTypes.func.isRequired,
  onClickExportTrigger: propTypes.func.isRequired,
  onClickSaveTrigger: propTypes.func.isRequired,
  scriptId: propTypes.string.isRequired
};
export default ScriptCreatorHeader;
